import angular from 'angular';

module.exports = angular.module('market.controllers', [
  require('./humans'),
])
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/controllers/index.js
 **/